
  import { Component, Prop, Vue ,Watch,Inject} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import {
    imgHost
  } from "@/utils/config"
import { number } from 'echarts';
  @Component({  
    name: '',
    components: {
      PageFooter,
      // VueCropper,
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:''}) modekey!:''
    private imgHost = imgHost
    private img = ''
    private defaultimg='/image/1677658403671.png'
    private isstart = false
    private marX:any = 0
    private marY:any = 0
    private imgheight = 0
    // private moveindex = -1
    @Inject() information:any
    get value(){
      return this.information
    }
    @Inject() editinfo:any
    get editmsg(){
      return this.information.find(v=>{
        return v.key == this.modekey
      })
    }
    get moveindex(){
      return this.editinfo.moveindex
    }

    private mounted () {
      
    }

    private down(e){
      // return 
      if(this.moveindex<0||this.modekey!=this.editinfo.msg.key) return 
      this.isstart = true
      this.imgheight = (this as any).$refs.cut.offsetHeight
      let marX = (e.offsetX*100/375).toFixed(0)
      let marY = (e.offsetY*100/this.imgheight).toFixed(0)
      this.marX = marX
      this.marY = marY

      this.editmsg.imglist[this.moveindex].marX = marX
      this.editmsg.imglist[this.moveindex].marY = marY
      this.editmsg.imglist[this.moveindex].width = 0
      this.editmsg.imglist[this.moveindex].height = 0
    }
    private move(e){
      if(!this.isstart||this.moveindex<0) return
      e.preventDefault()
      //当前鼠标x轴百分比
      // console.log((this as any).$refs.cut.offsetHeight,(this as any).$refs.cut.offsetWidth)
      let x:any = Number((e.offsetX *100/ 375 ).toFixed(0))
      let y:any = Number((e.offsetY *100/ this.imgheight).toFixed(0))
      //鼠标点击处的百分比
      let marX = JSON.parse(JSON.stringify(this.marX))
      let marY = JSON.parse(JSON.stringify(this.marY))
      //如果是向左上角选取 那么以最左上角的点为原点
      this.editmsg.imglist[this.moveindex].marX = x<marX?x:marX
      this.editmsg.imglist[this.moveindex].marY = y<marY?y:marY

      this.editmsg.imglist[this.moveindex].width = Math.abs(x-marX)
      this.editmsg.imglist[this.moveindex].height = Math.abs(y-marY)
      // console.log(marX,marY)
      // console.log(this.editmsg.imglist)
      this.$forceUpdate()
    }
    private end(e){
      if(this.modekey!=this.editinfo.msg.key) return
      this.editinfo.moveindex = -1
      this.isstart = false
    }

  }
